export default "/assets/images/mila-pan-video.378c5e34db148502.mp4";